import Link from "next/link";
import React from "react";

import Shell from "@calcom/features/shell/Shell";

export const HotlineIndexPage = () => {
  return (
    <Shell title="HotLine" heading="Hotline" subtitle="Hotline index page">
      <section className="mt-6 flex min-h-[70vh] flex-col items-center justify-center gap-4">
        <Link href="/hotline/meetings/" className="text-cyan-500 underline hover:text-cyan-600">
          My meetings
        </Link>
      </section>
    </Shell>
  );
};

export default HotlineIndexPage;
